var _context, _context2, _context3, _context4, _context5;
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
/* Fonts are hosted on AWS S3 static-files/fonts
 * e.g. https://dealroom-fargate-production.s3-us-west-2.amazonaws.com/staticfiles/fonts/Inter-Regular.ttf
 */

// Regular | 400px
export var Inter = {
  fontFamily: "Inter",
  fontStyle: "normal",
  fontWeight: "400",
  src: _concatInstanceProperty(_context = "\n        local('Inter-Regular'),\n        url('".concat(window.STATIC_URL, "fonts/Inter-Regular.ttf') format('truetype'),\n        url('")).call(_context, window.STATIC_URL, "fonts/Inter-Regular.woff2') format('woff2'),\n    ")
};

// Medium | 500px
export var InterMedium = {
  fontFamily: "Inter",
  fontStyle: "normal",
  fontWeight: "500",
  src: _concatInstanceProperty(_context2 = "\n        local('Inter-Medium'),\n        url('".concat(window.STATIC_URL, "fonts/Inter-Medium.ttf') format('truetype'),\n        url('")).call(_context2, window.STATIC_URL, "fonts/Inter-Medium.woff2') format('woff2'),\n    ")
};

// Semibold | 600px
export var InterSemiBold = {
  fontFamily: "Inter",
  fontStyle: "normal",
  fontWeight: "600",
  src: _concatInstanceProperty(_context3 = "\n        local('Inter-SemiBold'),\n        url('".concat(window.STATIC_URL, "fonts/Inter-SemiBold.ttf') format('truetype'),\n        url('")).call(_context3, window.STATIC_URL, "fonts/Inter-SemiBold.woff2') format('woff2'),\n    ")
};

// Semibold | 700px
export var InterBold = {
  fontFamily: "Inter",
  fontStyle: "normal",
  fontWeight: "700",
  src: _concatInstanceProperty(_context4 = "\n        local('Inter-Bold'),\n        url('".concat(window.STATIC_URL, "fonts/Inter-Bold.ttf') format('truetype'),\n        url('")).call(_context4, window.STATIC_URL, "fonts/Inter-Bold.woff2') format('woff2'),\n    ")
};

// Semibold | 800px
export var InterExtraBold = {
  fontFamily: "Inter",
  fontStyle: "normal",
  fontWeight: "800",
  src: _concatInstanceProperty(_context5 = "\n        local('Inter-ExtraBold'),\n        url('".concat(window.STATIC_URL, "fonts/Inter-ExtraBold.ttf') format('truetype'),\n        url('")).call(_context5, window.STATIC_URL, "fonts/Inter-ExtraBold.woff2') format('woff2'),\n    ")
};